module.exports = __webpack_public_path__ + "img/public/SiteIcons/expandIconNew.svg?ffedb339";